import NavComponent from "components/Navigation/NavComponent";
import DemoContext from "context/DemoContext";
import { AdminMeetings } from "Pages/dashboard/host/Meetings/Meetings";
import React, { useContext } from "react";
import { Tabs } from "react-bootstrap";
import MeetingStoreView from "../Payments/MeetingStoreView";

const StoreDemos = () => {
  let { demoRequests } = useContext(DemoContext);
  return (
    <>
      <Tabs
        defaultActiveKey="demo-history"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <NavComponent
          eventKey="demo-history"
          title="Video Meeting History"
          className=" payout-list-wrapper"
        >
          <MeetingStoreView />
        </NavComponent>
        <NavComponent
          eventKey="calender"
          title={`Video Meeting Calendar `}
          className="payout-list-wrapper"
        >
          <AdminMeetings />
        </NavComponent>
      </Tabs>
    </>
  );
};

export default StoreDemos;
